import { roundPrice } from './roundPrice';

export const formatPrice = (number: number): string => {
  if (number === 0) return '0';
  if (!number) return '';
  return roundPrice(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
